<template>
	<section 
		:class="panelClass">

		<div class="panel__frame">

      <ul v-if="this.tabs" class="panel__tab-list">
        <li class="panel__tab-item" v-for="(item, index) in this.$data.tablists[this.tabs]">
          <button :class="setCurrentTabClass(item.name)" @click='setCurrentTab(item.name)'>
            <Icon :icon="item.icon"></Icon>
            <span class="panel__tab-tip">{{item.title}}</span>
          </button>
        </li>
      </ul>

      <div v-if="this.save" class="panel__control">

        <div class="panel__buttons">
  
          <button class="button modal-default-button" @click="panelSave">{{ _translate('panel.save') }}</button>
          <button v-if="this.context === 'client'" class="button modal-default-button" @click="showDisclaimers">{{ _translate('panel.disclaimers') }}</button>

        </div>

      </div>   

      <div v-if="this.context === 'load'" class="panel__block panel__block--client-picker">

        <h2>{{ _translate('panel.selectClient') }}</h2>

        <ClientPicker id="spouse-picker" context="client"></ClientPicker>

      </div>

      <div v-if="this.context === 'client'" class="panel__block">

        <div v-if="isCurrentTab('details')" class="panel__tab">

          <h2 class="panel__heading">{{ _translate('panel.clientDetails') }}</h2>

          <Checkbox id="active" :label="_translate('panel.clientDeactivate')" field="details.deactivate" value="true"></Checkbox>

    	    <TextInput id="firstName" :label="_translate('panel.firstName')" field="details.firstName" type="text"></TextInput>

    	    <TextInput id="lastName" :label="_translate('panel.lastName')" field="details.lastName" type="text"></TextInput>

          <DatePicker id="dateOfBirth" :title="_translate('panel.useRetirementDate')" field="details.dateOfBirth" showage="true"></DatePicker>

          <Dropdown id="gender" field="details.gender" :label="_translate('panel.gender')" proto="gender"></Dropdown>

          <Dropdown id="maritalStatus" field="details.maritalStatus" :label="_translate('panel.maritalStatus')" proto="maritalStatus"></Dropdown>

          <Spouse :title="_translate('panel.spouse')" field="details.spouse"></Spouse>

          <TextInput id="source" :label="_translate('panel.source')" field="details.source" type="text"></TextInput>

          <Addr :title="_translate('panel.address')" field="details.address"></Addr>

          <TextInput id="phoneHome" :label="_translate('panel.homePhone')" field="details.phoneHome" type="text"></TextInput>

          <TextInput id="phoneWork" :label="_translate('panel.workPhone')" field="details.phoneWork" type="text"></TextInput>

          <TextInput id="phoneCell" :label="_translate('panel.cellPhone')" field="details.phoneCell" type="text"></TextInput>

          <TextInput id="fax" :label="_translate('panel.faxNumber')" field="details.fax" type="text"></TextInput>

          <TextInput id="email" :label="_translate('panel.email')" field="details.email" type="text"></TextInput>          

          <TextInput id="occupation" :label="_translate('panel.occupation')" field="details.occupation" type="text"></TextInput>          

          <TextInput id="employer" :label="_translate('panel.employer')" field="details.employer" type="text"></TextInput>          

          <Addr :title="_translate('panel.employerAddress')" field="details.employerAddress"></Addr>

          <h2 class="panel__heading">{{ _translate('panel.clientBeneficiary') }}</h2>

          <TextInput id="firstName" :label="_translate('panel.firstName')" field="details.beneficiaryFirstName" type="text"></TextInput>

          <TextInput id="lastName" :label="_translate('panel.lastName')" field="details.beneficiaryLastName" type="text"></TextInput>          

          <TextInput id="lastName" :label="_translate('panel.age')" field="details.beneficiaryAge" type="age"></TextInput>          

          <h2 class="panel__heading">{{ _translate('panel.clientExecutor') }}</h2>

          <TextInput id="firstName" :label="_translate('panel.firstName')" field="details.executorFirstName" type="text"></TextInput>

          <TextInput id="lastName" :label="_translate('panel.lastName')" field="details.executorLastName" type="text"></TextInput>          

          <TextInput id="lastName" :label="_translate('panel.age')" field="details.executorAge" type="age"></TextInput>          

        </div>

        <div v-else-if="isCurrentTab('income')" class="panel__tab">

          <h2 class="panel__heading">{{ _translate('panel.incomeDetails') }}</h2>

          <TextInput id="presentIncome" :label="_translate('panel.presentIncome')" field="income.presentIncome" type="currency"></TextInput>

          <TextInput id="otherSources" :label="_translate('panel.incomeOtherSources')" field="income.otherSources" type="currency"></TextInput>
         
        </div> 

        <div v-else-if="isCurrentTab('government')" class="panel__tab">

          <h2 class="panel__heading">{{_translate('panel.pension')}}</h2>

          <TextInput id="pensionAge" :label="_translate('panel.pensionAge')" field="retirement.pensionAge" type="age"></TextInput>

          <TextInput id="pensionIndex" :label="_translate('panel.indexPension')" field="retirement.pensionIndex" type="percentage"></TextInput>

          <TextInput id="pensionBenefit" :label="_translate('panel.pensionBenefit')" field="retirement.pensionBenefit" type="currency"></TextInput>

          <Checkbox id="cppIntegrate" :label="_translate('panel.cppIntegrate')" field="retirement.cppIntegrate" value="true"></Checkbox>

          <Checkbox id="hasBridgeBenefit" :label="_translate('panel.hasBridgeBenefit')" field="retirement.hasBridgeBenefit" value="true"></Checkbox>

          <TextInput v-if="showFromCheckbox('retirement.hasBridgeBenefit')" id="bridgeValue" :label="_translate('panel.bridgeValue')" field="retirement.bridgeValue" type="currency"></TextInput>

          <TextInput v-if="showFromCheckbox('retirement.hasBridgeBenefit')" id="bridgeStart" :label="_translate('panel.bridgeStart')" field="retirement.bridgeStart" type="age"></TextInput>

          <TextInput v-if="showFromCheckbox('retirement.hasBridgeBenefit')" id="bridgeEnd" :label="_translate('panel.bridgeEnd')" field="retirement.bridgeEnd" type="age"></TextInput>          

          <h2 class="panel__heading">{{ _translate('panel.cppTitle') }}</h2>

          <TextInput id="cppAtAge" :label="_translate('panel.cppAtAge')" field="retirement.cppAtAge" type="age"></TextInput>

          <TextInput id="cppIndex" :label="_translate('panel.cppIndex')" field="retirement.cppIndex" type="percentage"></TextInput>          

          <Checkbox id="cppCustomValue" :label="_translate('panel.cppCustomValue')" field="retirement.cppCustomValue" value="true"></Checkbox>

          <TextInput v-if="showFromCheckbox('retirement.cppCustomValue')" id="cppValue" :label="_translate('panel.cppValue')" field="retirement.cppValue" type="currency"></TextInput>

          <h2 class="panel__heading">{{ _translate('panel.oasTitle') }}</h2>

          <TextInput id="oasAtAge" :label="_translate('panel.oasAtAge')" field="retirement.oasAtAge" type="age"></TextInput>

          <TextInput id="oasIndex" :label="_translate('panel.oasIndex')" field="retirement.oasIndex" type="percentage"></TextInput>

          <Checkbox id="oasCustomValue" :label="_translate('panel.oasCustomValue')" field="retirement.oasCustomValue" value="true"></Checkbox>

          <TextInput v-if="showFromCheckbox('retirement.oasCustomValue')" id="oasValue" :label="_translate('panel.oasValue')" field="retirement.oasValue" type="currency"></TextInput>

        </div>

        <div v-else-if="isCurrentTab('retirement')" class="panel__tab">

          <h2 class="panel__heading">{{ _translate('panel.generalTitle') }}</h2>

          <Checkbox id="useRetirementDate" :label="_translate('panel.useRetirementDate')" field="retirement.useRetirementDate" value="true"></Checkbox>

          <TextInput v-if="!showFromCheckbox('retirement.useRetirementDate')" id="retirementAge" :label="_translate('panel.retireAge')" field="retirement.retirementAge" type="age"></TextInput>

          <DatePicker v-if="showFromCheckbox('retirement.useRetirementDate')" id="retirementDate" :title="_translate('panel.retirementDate')" field="retirement.retirementDate" showage="true" yearOrder="asc"></DatePicker>

          <TextInput id="requiredAtRetirement" :label="_translate('panel.perentageIncome')" field="retirement.requiredAtRetirement" type="percentage"></TextInput>

          <TextInput id="passiveRetirementAge" :label="_translate('panel.passiveRetireAge')" field="retirement.passiveRetirementAge" type="age"></TextInput>

          <TextInput id="passiveIncomeRequired" :label="_translate('panel.percentagePassiveIncome')" field="retirement.passiveIncomeRequired" type="percentage"></TextInput>

          <TextInput id="lifeExpectancy" :label="_translate('panel.lifeExpectancy')" field="retirement.lifeExpectancy" type="age"></TextInput>

          <TextInput id="estateValue" :label="_translate('panel.estateTarget')" field="retirement.estateValue" type="currency"></TextInput>      

          <TextInput id="inflationRate" :label="_translate('panel.inflationRate')" field="retirement.inflationRate" type="percentage"></TextInput>

          <h2 class="panel__heading">{{ _translate('panel.retirementPlanTitle') }}</h2>

          <Dropdown id="startPlan" field="retirement.startPlan" :label="_translate('panel.startPlanIn')" proto="yearsRange"></Dropdown>

          <Dropdown id="withdrawalOrder" field="retirement.withdrawalOrder" :label="_translate('panel.withdrawalOrder')" proto="withdrawalOrder"></Dropdown>

          <Dropdown id="autofillShortfall" field="retirement.autofillShortfall" :label="_translate('panel.automaticShortfalls')" proto="trueFalse"></Dropdown>

          <TextInput id="fromSavings" :label="_translate('panel.percentagefromSavings')" field="retirement.fromSavings" type="percentage"></TextInput>

          <TextInput id="fromLockedin" :label="_translate('panel.percentagefromLockedin')" field="retirement.fromLockedin" type="percentage"></TextInput>

          <TextInput id="fromTfsa" :label="_translate('panel.percentagefromTFSA')" field="retirement.fromTfsa" type="percentage"></TextInput>

          <TextInput id="fromRegistered" :label="_translate('panel.percentagefromRegistered')" field="calc.fromRegistered" type="percentage" disabled="true"></TextInput>

        </div>       

        <div v-else-if="isCurrentTab('savings')" class="panel__tab">

          <h2 class="panel__heading">{{ _translate('panel.nonregisteredTitle') }} <span v-html="sumRepeaters([
            'savings.open.chequing', 
            'savings.open.savings', 
            'savings.open.mutualFunds', 
            'savings.open.stocks', 
            'savings.open.other'
          ], 'balance')"></span></h2>

    	    <Repeater :title="_translate('panel.chequingAccounts')" field="savings.open.chequing" totalby="balance" proto="account" ></Repeater>

    	    <Repeater :title="_translate('panel.savingsAccounts')" field="savings.open.savings" totalby="balance" proto="account"></Repeater>

          <!-- <Repeater title="Bonds" field="savings.open.bonds" totalby="balance" proto="account"></Repeater> -->

          <Repeater :title="_translate('panel.stocks')" field="savings.open.stocks" totalby="balance" proto="account"></Repeater>

          <Repeater :title="_translate('panel.mutualFunds')" field="savings.open.mutualFunds" totalby="balance" proto="account"></Repeater>

          <!-- <Repeater title="GICs" field="savings.open.gics" totalby="balance" proto="gic"></Repeater> -->

          <Repeater :title="_translate('panel.other')" field="savings.open.other" totalby="balance" proto="account"></Repeater> 

          <h2 class="panel__heading">{{ _translate('panel.tfsaTitle') }} <span v-html="sumRepeaters([
            'savings.open.tfsa',            
          ], 'balance')"></span></h2>

          <Repeater :title="_translate('panel.tfsa')" field="savings.open.tfsa" totalby="balance" proto="account"></Repeater>

          <h2 class="panel__heading">{{ _translate('panel.registeredTitle') }} <span v-html="sumRepeaters([ 
            'savings.registered.mutualFunds', 
            'savings.registered.other',
            'savings.registered.rrif',
          ], 'balance')"></span></h2>

          <div class="savings-wrap">
          <Repeater :title="_translate('panel.mutualFunds')" field="savings.registered.mutualFunds" totalby="balance" proto="account"></Repeater>

          <!--<Checkbox id="minmax_registered_mutualFunds" :label="_translate('panel.useMinMax')" field="savings.minmax_registered_mutualFunds" value="true"></Checkbox>-->          
          </div>

          <Repeater :title="_translate('panel.other')" field="savings.registered.other" totalby="balance" proto="account"></Repeater>

          <div class="savings-wrap">
            <Repeater :title="_translate('panel.rrif')" field="savings.registered.rrif" totalby="balance" proto="retirementAccount"></Repeater>

            <!-- <Checkbox id="minmax_registered_rrif" :label="_translate('panel.useMinMax')" field="savings.minmax_registered_rrif" value="true"></Checkbox> -->
          </div>        

          <h2 class="panel__heading">{{ _translate('panel.dpspTitle') }} <span v-html="sumRepeaters([ 
            'savings.registered.dpspEsopGrsp', 
          ], 'balance')"></span></h2>

          <div class="savings-wrap">
            <Repeater :title="_translate('panel.dpsp')" field="savings.registered.dpspEsopGrsp" totalby="balance" proto="retirementAccount"></Repeater>

            <!-- <Checkbox id="minmax_registered_dpspEsopGrsp" :label="_translate('panel.useMinMax')" field="savings.minmax_registered_dpspEsopGrsp" value="true"></Checkbox> -->
          </div>

          <h2 class="panel__heading">{{ _translate('panel.otherTitle') }} <span v-html="sumRepeaters([
            'savings.lockedin.employerPension', 
            'savings.lockedin.lockedRrsp', 
          ], 'balance')"></span></h2>

          <div class="savings-wrap">
            <Repeater :title="_translate('panel.employerPensionPlan')" field="savings.lockedin.employerPension" totalby="balance" proto="retirementAccount"></Repeater>

            <Checkbox id="minmax_lockedin_pension" :label="_translate('panel.useMinMax')" field="savings.minmax_lockedin_pension" value="true"></Checkbox>
          </div>

          <div class="savings-wrap">
            <Repeater :title="_translate('panel.rrsp')" field="savings.lockedin.lockedRrsp" totalby="balance" proto="retirementAccount"></Repeater>

            <Checkbox id="minmax_lockedin_lockedRrsp" :label="_translate('panel.useMinMax')" field="savings.minmax_lockedin_lockedRrsp" value="true"></Checkbox>
          </div>        

          <h2 class="panel__heading">{{ _translate('panel.annualValuesTitle') }}</h2>  

          <Repeater :title="_translate('panel.annualValues')" field="savings.periodicValues.values" totalby="balance" display="last" proto="periodicValues" autofill="autofillValueTotals"></Repeater>

          <Repeater v-if="useAdjustments" :title="_translate('panel.adjustedContributions')" field="retirement.adjustedContributions" totalby="none" display="last" proto="contributions"></Repeater>          

          <Repeater v-if="useAdjustments" :title="_translate('panel.adjustedWithdrawals')" field="retirement.adjustedWithdrawals" totalby="none" display="last" proto="withdrawals"></Repeater>  

        </div>

        <div v-else-if="isCurrentTab('assets')" class="panel__tab">

          <h2 class="panel__heading">{{ _translate('panel.realEstateTitle') }} <span v-html="sumRepeaters([
            'assets.realEstate.home', 
            'assets.realEstate.other',  
          ], 'value')"></span></h2>

          <Repeater :title="_translate('panel.personalHomes')" field="assets.realEstate.home" totalby="value" proto="realEstate" ></Repeater>

          <Repeater :title="_translate('panel.otherRealEstate')" field="assets.realEstate.other" totalby="value" proto="realEstate"></Repeater>

          <h2 class="panel__heading">{{ _translate('panel.businessInterestsTitle') }} <span v-html="sumRepeaters([
            'assets.other.businessInterests', 
          ], 'value')"></span></h2>

          <Repeater :title="_translate('panel.businessInterests')" field="assets.other.businessInterests" totalby="value" proto="property"></Repeater>

          <h2 class="panel__heading">{{ _translate('panel.otherAssetsTitle') }} <span v-html="sumRepeaters([
            'assets.other.taxDefered',
            'assets.other.other', 
          ], 'value')"></span></h2>

          <Repeater :title="_translate('panel.taxDeferredAssets')" field="assets.other.taxDefered" totalby="value" proto="property"></Repeater>

          <Repeater :title="_translate('panel.otherAssets')" field="assets.other.other" totalby="value" proto="property"></Repeater>

        </div>        

        <div v-else-if="isCurrentTab('debt')" class="panel__tab">

          <h2 class="panel__heading">{{ _translate('panel.shortTermDebtTitle') }} <span v-html="sumRepeaters([
              'debt.shortTerm.creditCards', 
              'debt.shortTerm.carLoans',  
              'debt.shortTerm.lineOfCredit', 
              'debt.shortTerm.other',  
            ], 'balance')"></span></h2>

          <Repeater :title="_translate('panel.creditCards')" field="debt.shortTerm.creditCards" totalby="balance" proto="debtAccount"></Repeater>

          <Repeater :title="_translate('panel.carLoans')" field="debt.shortTerm.carLoans" totalby="balance" proto="debtAccount"></Repeater>

          <Repeater :title="_translate('panel.lineOfCredit')" field="debt.shortTerm.lineOfCredit" totalby="balance" proto="debtAccount"></Repeater>

          <Repeater :title="_translate('panel.otherDebts')" field="debt.shortTerm.other" totalby="balance" proto="debtAccount"></Repeater>                              
          <h2 class="panel__heading">{{ _translate('panel.longTermDebtTitle') }} <span v-html="sumRepeaters([
            'debt.longTerm.mortgageHome', 
            'debt.longTerm.mortgageOther',  
            'debt.longTerm.investmentLoans', 
          ], 'balance')"></span></h2>

          <Repeater :title="_translate('panel.homeMortgage')" field="debt.longTerm.mortgageHome" totalby="balance" proto="mortgage"></Repeater>

          <Repeater :title="_translate('panel.otherMortgages')" field="debt.longTerm.mortgageOther" totalby="balance" proto="mortgage"></Repeater>

          <Repeater :title="_translate('panel.investmentLoans')" field="debt.longTerm.investmentLoans" totalby="balance" proto="account"></Repeater>

        </div>

        <div v-else-if="isCurrentTab('insurance')" class="panel__tab">

          <h2 class="panel__heading">{{ _translate('panel.lifeInsuranceTitle') }}</h2>

          <TextInput id="group" :label="_translate('panel.insuranceGroup')" tmp="Group" field="insurance.group" type="currency"></TextInput>

          <TextInput id="life" :label="_translate('panel.lifeInsurance')" tmp="Life Insurance" field="insurance.life" type="currency"></TextInput>

          <h2 class="panel__heading">{{ _translate('panel.lifeInsuranceNeedsTitle') }}</h2>

          <TextInput id="employerLife" :label="_translate('panel.employerLifeInsurance')" tmp="Employer Life Insurance" field="insurance.employerLife" type="currency"></TextInput>

          <TextInput id="mortgage" :label="_translate('panel.mortgageInsurance')" tmp="Mortgage Insurance" field="insurance.mortgage" type="currency"></TextInput>

          <h2 class="panel__heading">{{ _translate('panel.cashRequiredTitle') }}</h2>

          <TextInput id="funeralExpenses" :label="_translate('panel.funeralExpenses')" tmp="Funeral Expenses" field="retirement.funeralExpenses" type="currency"></TextInput>

          <TextInput id="legalFees" :label="_translate('panel.estateFees')" tmp="Probate, Executor, Legal, Accounting Fees" field="retirement.legalFees" type="currency"></TextInput>

          <TextInput id="shortTermLiving" :label="_translate('panel.shortTermLivingExpenses')" tmp="Short Term Living Expenses" field="retirement.shortTermLiving" type="currency"></TextInput>

          <TextInput id="education" :label="_translate('panel.postSecondaryExpenses')" tmp="Post Secondary Education for Children" field="retirement.education" type="currency"></TextInput>          
          <h2 class="panel__heading">{{ _translate('panel.insuranceCashValueTitle') }}</h2>

          <TextInput id="insuranceCashValue" :label="_translate('panel.lifeInsuranceCashValue')" tmp="Life Insurance Cash Value" field="insurance.insuranceCashValue" type="currency"></TextInput>

          <h2 class="panel__heading">{{ _translate('panel.capitalGainsTitle') }}</h2>

          <TextInput id="adjustedRealEstate" :label="_translate('panel.adjustedCostRealEstate')" tmp="Adjusted Cost Basis of Real Estate" field="insurance.adjustedRealEstate" type="currency"></TextInput>

          <TextInput id="taxableCapitalGains" :label="_translate('panel.taxableCapitalGains')" tmp="Taxable Portion of Capital Gains" field="insurance.taxableCapitalGains" type="percentage"></TextInput>           

        </div>        

      </div>

      <div v-if="this.context === 'tools'" class="panel__block">

          <h2 class="panel__heading">{{ _translate('panel.toolsTitle') }}</h2>
          <Tool context="savingsFuture" :title="_translate('panel.toolSavingsFuture')" tmp="Savings Required for Future" icon="pig"></Tool>      
          <Tool context="investmentFuture" :title="_translate('panel.toolFutureValue')" tmp="Future Value of an Investment" icon="future-value"></Tool>      
          <Tool context="regularWithdrawals" :title="_translate('panel.toolRegularWithdrawals')" tmp="Regular Withdrawals from an Investment" icon="regular-withdrawals"></Tool>      
          <Tool context="systematicWithdrawals" :title="_translate('panel.toolSystematicWithdrawals')" tmp="Systematic Withdrawals from an Investment" icon="systematic-withdrawals"></Tool>      

      </div>

      <div v-if="this.context === 'snapshots'" class="panel__block">

          <h2 class="panel__heading">{{ _translate('panel.snapshotsTitle') }}</h2>
          <p class="panel__instruction">{{ _translate('panel.snapshotInstructionIntro') }}<span v-html="setCurrentSnapshotInstructions()"></span>.</p>
          <ul :key="this.key" class="panel__snapshots-list">
            <li class="panel__snapshots-item">
              <div class="panel__snapshots-ctrl">
              <button :class="setSnapshotButtonClass('current')" @click="setCurrentSnapshot('current')">{{ _translate('panel.useCurrentData') }}</button>
              </div>           
            </li>            
            <li class="panel__snapshots-item" v-for="(item, index) in this.getSnapshots()">
              <div class="panel__snapshots-ctrl">
              <button :class="setSnapshotButtonClass(index)" @click="setCurrentSnapshot(index)">{{ getSnapshotDate(index) }}</button>
              <button class="edit" @click="editSnapshotDate(index)"><Icon icon="pencil"></Icon><span>{{ _translate('ui.edit') }}</span></button>
              <button class="remove" @click="deleteSnapshot(index)"><span>{{ _translate('ui.delete') }}</span></button>
              <span v-if="isGPSData(index)" class="gps_fixed"><Icon icon="link"></Icon></span>
              </div>
              <DatePicker v-if="snapshotedit == index"  v-on:updateDate="finishUpdateSnapshotDate" id="changeSnapshot" title="Change Date" field="snapshot" context="snapshot" :snapshot="index"></DatePicker>              
            </li>
          </ul>          
          <button class="button button--snapshot" @click="takeSnapshot"><Icon icon="camera"></Icon>{{ _translate('panel.takeSnapshot') }}</button>

      </div>      

      <div v-if="this.context === 'settings' && isCurrentTab('language')" class="panel__block">

          <h2 class="panel__heading">{{ _translate('panel.applicationLanguageTitle') }}</h2>
          <p class="panel__instruction" v-html="setLanguageSwitcherText('detail')"></p>
          <button class="button panel__button" @click="setAppLanguage()" v-html="setLanguageSwitcherText('button')"></button>         

      </div>

      <div v-if="this.context === 'settings' && isCurrentTab('constants')" class="panel__block">

          <h2 class="panel__heading">{{ _translate('panel.constantsTitle') }}</h2>
          <TextInput id="currentYear" :label="_translate('panel.constantCurrentYear')" tmp="Current Year" field="currentYear" type="text" setting="true"></TextInput>
          <TextInput id="maxOASPay" :label="_translate('panel.constantMaximumOasPayout')" tmp="Maximum Monthly OAS Payout" field="maxOASPay" type="currency" setting="true"></TextInput>
          <TextInput id="maxOASThresh" :label="_translate('panel.constantMaximumOasIncomeThreshold')" tmp="Maximum OAS Income Threshold" field="maxOASThresh" type="currency" setting="true"></TextInput>
          <TextInput id="maxCPPPay" :label="_translate('panel.constantMaximumCppPayout')" tmp="Maxmium CPP Payout" field="maxCPPPay" type="currency" setting="true"></TextInput>
          <TextInput id="maxCPPThresh" :label="_translate('panel.constantMaximumCppIncomeThreshold')" tmp="Maximum CPP Income Threshold" field="maxCPPThresh" type="currency" setting="true"></TextInput>
          <TextInput id="cppBenefit" :label="_translate('panel.constantCppDeathBenefit')" tmp="CPP Death Benefit" field="cppBenefit" type="currency" setting="true"></TextInput>
          <TextInput id="survivorPension" :label="_translate('panel.constantSurvivorPension')" tmp="Survivor's Pension" field="survivorPension" type="currency" setting="true"></TextInput>
          <Repeater :title="_translate('panel.constantLifSchedule')" tmp="LIF Schedule" field="lifSchedule" totalby="none" proto="lifSchedule" setting="true"></Repeater>          

      </div>

      <div v-if="this.context === 'settings' && isCurrentTab('disaster')" class="panel__block">

          <h2 class="panel__heading">{{ _translate('panel.disasterTitle') }}</h2>

          <Repeater :title="_translate('panel.shockEvents')" field="shockEvents" totalby="none" proto="shockEvents" setting="true"></Repeater>          

      </div>

      <div v-if="this.context === 'settings' && isCurrentTab('print')" class="panel__block">

          <h2 class="panel__heading">{{ _translate('panel.printOptionsTitle') }}</h2>

          <TextInput id="printTitle" :label="_translate('panel.defaultPrintTitle')" field="printTitle" type="text" setting="true"></TextInput>
          <TextInput id="printTitle" :label="_translate('panel.defaultPrintTitleFr')" field="printTitleFr" type="text" setting="true"></TextInput>          
          <Repeater :title="_translate('panel.disclaimers')" field="disclaimers" totalby="none" proto="disclaimers" setting="true"></Repeater>          

      </div>

    </div>

    <div :class="setExtendedClass" v-if="this.sub === 'true'">

      <div class="panel__frame">

        <component :is="currentView"></component>

      </div> 

      <div class="panel__extend-control">

        <div class="repeater-form__buttons">

          <div class="repeater-form__buttons-left">
          
            <button v-if="this.context !== 'tools'" class="button modal-default-button" @click="closeSubpanel">{{ _translate('ui.save') }}</button>      
            <button class="button modal-default-button" @click="cancelSubpanel">{{ _translate('ui.cancel') }}</button>

          </div><div class="repeater-form__buttons-right">
  
            <button v-if="isRepeater()" class="button modal-default-button" @click="addRow">{{ _translate('ui.add') }}</button>

          </div>

        </div>

      </div>      

    </div>

	</section>
</template>

<script>

import Addr         from './Address.vue'
import AddressForm  from './AddressForm.vue'
import Checkbox     from './Checkbox.vue'
import ClientPicker from './ClientPicker.vue'
import DatePicker   from './DatePicker.vue'
import Dropdown     from './Dropdown.vue'
import Icon         from './Icon.vue'
import Repeater     from './Repeater.vue'
import RepeaterForm from './RepeaterForm.vue'
import Spouse       from './Spouse.vue'
import SpouseForm   from './SpouseForm.vue'
import TextInput    from './TextInput.vue'
import Tool         from './Tool.vue'
import ToolPanel    from './ToolPanel.vue'


export default {


  /**
   * COMPONENTS
   * ----------
   * 
   * These are the components that can be used by this 
   * component
   */
  
	components: {
    Addr,
    AddressForm,
    Checkbox,
    ClientPicker,
    DatePicker,
    Dropdown,
    Icon,
    Repeater,
    RepeaterForm,
    Spouse,
    SpouseForm,
    TextInput,
    Tool,
    ToolPanel,
  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

    panelClass() {

      /**
       * State Controller for sub-panel
       *
       * @since  1.2.5
       * The State controller allows us to control aspects of the
       * panel component from the state.
       */
      
      if ( this.controller ) {

        var controllers = this.$store.getters.getControllers;

        if ( controllers[this.controller] ) {

          var controller  = controllers[this.controller];

          if ( controller.forceClose ) {

            this.closeSubpanel();

            this.$store.dispatch('setCurrentTool', false); 
            this.$store.dispatch('setController', {
              area: 'tools',
              prop: 'forceClose',
              val:  false,
            });

          } 
            
         
        } 

      }       

      var c = 'panel';

      if (this.tabs) {

        c += ' panel--tabs';

      }

      if (this.save) {

        c += ' panel--controls';

      }

      if (this.$data.subpanel.state !== 'hidden') {

        c += ' js-extend';

      }

      c += ' panel--' + Math.round(100 / this.width);
      c += ' panel--' + this.align;

      c += ( this.context === this.$parent.$data.view ) ? ' js-active' : '';

      return c;

    },

    panelContent() {

      return 'Panel Content';

    },

    currentView() {

      return this.views[this.$data.subpanel.view];

    },    

    setExtendedClass() {     

      var c = 'panel__extend';

      if ( this.subwidth.substr(0,1) === 'x' ) {

        c += ' panel--x' + Number(this.subwidth.substr(1));

      }

      else {

        c += ' panel--' + Math.round(100 / this.subwidth);

      }

      if ( (this.$data.subpanel.state !== 'hidden') ) {

        c += ' js-active';

      }

      return c;

    },

    useAdjustments() {

      return this.$store.getters.getFieldData({field: 'retirement.useAdjusted'});

    },

  },


  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

    getSubpanelData() {

      return this.$data.subpanel;

    },

    addRow(e) {

      for ( var x = 0; x < this.$children.length; x++ ) {

        if ( this.$children[x].addRow !== undefined ) {

          this.$children[x].addRow(e);

        }

      }

    },

    closeSubpanel() {

      this.$data.subpanel.state = 'hidden';
      this.$data.key += 1;

    },

    cancelSubpanel() {

      var data    = this.$data.subpanel.save,
          field   = this.$data.subpanel.field,
          setting = this.$data.subpanel.setting,
          self    = this;

      this.closeSubpanel();    

      window.resetData = setTimeout(function(){

        if ( self.$data.subpanel.view === 'repeaterForm') {

          self.$store.dispatch('saveRepeater', {
            field: field,
            data:  data,
            setting: setting,
          });

        }

        else if ( self.$data.subpanel.view === 'spouseForm' ) {

          self.$store.dispatch('saveField', {
            field: field,
            value: data.id,
          });

          self.$store.dispatch('updateSpouseState', data.spouse);
          
        }

        else if ( self.$data.subpanel.view === 'toolPanel') {

          self.$store.dispatch('setCurrentTool', false); 
          
        }

        else {

          self.$store.dispatch('saveField', {
            field: field,
            value: data,
          });

        }       

      }, 30);

    },

    isRepeater() {

      return (this.$data.subpanel.view === 'repeaterForm');

    },

    isCurrentTab(tab) {

      var currentTab = this.$data.currentTab;

      if ( ! currentTab ) {

        currentTab = this.$data.tablists[this.tabs][0].name;

      }

      if ( tab === currentTab ) {

        return true;

      }

      return false;

    },

    setCurrentTab(tab) {

      this.$data.currentTab = tab;

    },

    setAppLanguage() {

      this.$store.dispatch('setAppLanguage');

    },

    setLanguageSwitcherText(context = 'button') {

      if ( context === 'button' ) {
        return this._translate('panel.languageSwitcherButton');
      } else {
        return this._translate('panel.languageSwitcherText');
      }

    },

    setCurrentTabClass(tab) {

      var c = 'panel__tab-button',
          activeTab = this.$data.currentTab;

      if ( ! activeTab ) {

        activeTab = this.$data.tablists[this.tabs][0].name;

      }

      if ( tab === activeTab ) {

        c += ' js-active';

      }

      return c;

    },

    sumRepeaters(fields, totalby) {

      var v = '',
          total = 0;

      for ( var x = 0; x < fields.length; x++ ) {

        total += this.$store.getters.getRepeaterTotal({field: fields[x], totalby: totalby})

      }

      return '- <span class="sum">$' + window.thousandSeparators(total.toFixed(2) + '');  + '</span>';

    },

    validateClientPanel() {

      var client = this.$store.getters.getAllData();

      if ( client.details.firstName.trim() === '' ||
           client.details.lastName.trim()  === '' ) {

        return false;

      }

      return true;

    },

    showDisclaimers() {

      this.$store.dispatch('openModal', 'disclaimers');

    },

    panelSave() {

      this.$parent.$data.working = true;

      if ( this.save === 'saveClient' ) {

        if ( ! this.validateClientPanel() ) {

          this.$parent.$data.working = false;
          return false;

        }

        var client = this.$store.getters.getAllData(),
            request_uri = window.api_uri + 'api/a23jf6x002d500as/save/client/' + client.id;

        this.axios.post(request_uri, {
          client
        })
        .then(response => {
          
          if ( response.data.id !== undefined ) {

            this.$store.dispatch('updateClientId', response.data.id);

          }

          this.$store.dispatch('updateClientListDeactivate', { 
            id: client.id,
            firstName: client.details.firstName,
            lastName:  client.details.lastName, 
            deactive:  client.details.deactivate ? client.details.deactivate : ''
          });

          this.$parent.workingTimeout();         

        }, 

        response => {
         
          if ( response.data.error ) {

            window.console.log(resonse.data);

          }

          this.$parent.workingTimeout();         

        });        

      }

      else if ( this.save === 'saveConstants' ) {

        var app_constants = this.$store.getters.getConstants(),
            request_uri = window.api_uri + 'api/a23jf6x002d500as/save/constants/';

        this.axios.post(request_uri, {
          app_constants
        })
        .then(response => {
          
          this.$parent.workingTimeout();        

        }, 

        response => {
         
          if ( response.data.error ) {

            window.console.log(resonse.data);

          }

          this.$parent.workingTimeout();                  

        });        

      }

    },

    showFromCheckbox(type) {

      return this.$store.getters.getFieldData({field: type});

    },

    takeSnapshot() {

      var today = new Date(),
          dd = window.padDigits(today.getDate(),2),
          mm = window.padDigits(today.getMonth()+1,2),
          yyyy = today.getFullYear(),
          client = this.$store.getters.getClientObject,
          snap = {
            'assets' : window.rawObject(client.assets),
            'debt' : window.rawObject(client.debt),
            'income' : window.rawObject(client.income),
            'insurance' : window.rawObject(client.insurance),
            'retirement' : window.rawObject(client.retirement),
            'savings' : window.rawObject(client.savings),
          };

      var data = {
        date : yyyy.toString() + mm.toString() + dd.toString(),
        snapshot : snap,
      }

      this.$store.dispatch('takeCurrentSnapshot', data);
      this.$data.key += 1;

    },

    setCurrentSnapshot (date) {

      this.$store.dispatch('setCurrentSnapshot', { date: date });
      this.$emit('updateApp');

    },

    getCurrentSnapshot() {

      return this.$store.getters.getCurrentSnapshot;

    },

    setSnapshotButtonClass(index) {

      var c = 'snapshot',
          snapshot = this.getCurrentSnapshot();

      if ( snapshot === index ) {

        c += ' js-active';

      }

      return c;

    },

    setCurrentSnapshotInstructions() {

      var report = this.$store.getters.getCurrentReport;

      if (report === 'financialgps') {
        return this._translate('panel.snapshotInstructionGPS');
      }
      else {
        return this._translate('panel.snapshotInstructionPlanner');
      }


    },

    deleteSnapshot(date) {

      if ( confirm('Are you sure you want to delete this snapshot? Once the client data is saved, this CANNOT be undone') ) {

        this.$store.dispatch('deleteSnapshot', { date: date });
        this.$data.snapshotedit = 0;
        this.$data.key += 1;

      }

    },

    editSnapshotDate(date) {

      this.$data.snapshotedit = date;
      this.$data.key += 1;

    },

    getSnapshots() {

      var snapshots = this.$store.getters.getFieldData({ field: 'snapshots.snapshots' });
      return snapshots

    },

    getSnapshotDate(d) {

      var date = new Date(d.substr(0,4) + '/' + d.substr(4,2) + '/' + d.substr(6)); 
      return date.toCustomString();

    },

    finishUpdateSnapshotDate() {

      this.$data.snapshotedit = 0;
      this.$data.key += 1;

    },

    isGPSData(key) {

      var gps = this.$store.getters.getFieldData({field: 'snapshots.gps'});
      return ( gps === key );

    },

    autoSave() {

      if ( this.$parent.$data.view !== 'start' ) {

        this.panelSave();
        
      }

      var self = this;

      window.autoSave = setTimeout(function(){

        self.autoSave();

      }, 180000);

    }

  },


  /**
   * PROPS
   * -----
   * 
   * These are the properties that can be passed to the 
   * component. These can be used to configure the component
   * from within templates
   */   

  props : [
    'sub',
    'align',
    'width',
    'subwidth',
    'context',
    'tabs',
    'save',
    'controller',
  ],

  mounted: function() {

    var self = this;

    if ( this.context === 'client') {

      window.autoSave = setTimeout(function(){

        self.autoSave();

      }, 180000);

    }

  },

  data() {

    return {

      subpanel: {

        state: 'hidden',
        title: 'No Title',
        field: '',
        proto: false,
        context: false,
        view: '',
        data: {},
        save: {},

      },

      tablists: {

        client: [
          { 
            name: 'details',
            icon: 'client',
            title: 'Client'
          },
          {
            name: 'income',
            icon: 'dollar',
            title: 'Income',
          },
          {
            name: 'government',
            icon: 'government',
            title: 'Pensions',
          },          {
            name: 'retirement',
            icon: 'sun',
            title: 'Retirement',
          },
          {
            name: 'savings',
            icon: 'savings',
            title: 'Savings',
          },          
          {
            name: 'assets',
            icon: 'house',
            title: 'Assets',
          },          
          {
            name: 'debt',
            icon: 'debt',
            title: 'Debt',
          },                   
          {
            name: 'insurance',
            icon: 'umbrella',
            title: 'Insurance',
          },
          // {
          //   name: 'shortfall',
          //   icon: 'scale',
          //   title: 'Shortfall/Excess',
          // },           
        ],

        settings: [
          { 
            name: 'language',
            icon: 'bubble',
            title: 'Language'
          },
          { 
            name: 'constants',
            icon: 'cube',
            title: 'Constants'
          },
          {
            name: 'disaster',
            icon: 'disaster',
            title: 'Disaster',
          },
          {
            name: 'print',
            icon: 'print',
            title: 'Printing',
          }         
        ],        

      },

      currentTab: false,

      views: {

        'repeaterForm' : RepeaterForm,
        'addressForm' : AddressForm,
        'spouseForm' : SpouseForm,
        'toolPanel' : ToolPanel,

      },

      key: 0,
      snapshotedit: 0,
      snapshotdate: {
        year: 0,
        month: 0,
        day: 0,
      }

    }

  }

}

</script>

<style lang="scss">

	.panel {

		position: absolute;
		top: 0;
		bottom: 0;

    transform: translate3d(-100%, 0, 0);
    transition: transform .7s ease;


    z-index: 10;

    &.js-active {

      transform: translate3d(0, 0, 0);

      .panel__extend {

        &.js-active {

          transform: translate3d(100%, 0, 0);

        }

      }

    }

    &.panel--100 {

      width: 100%;

    }

    &.panel--50 {

      width: 50%;

    }

    &.panel--33 {

      width: 33.3333%;

    }

    &.panel--25 {

      width: 25%;

    }

    &.panel--left {

      left: 0;
      border-right: 1px solid rgba(255, 255, 255, .25);

      .panel__extend {

        &.panel--50 {

          left: 50%;

        }

        &.panel--33 {

          left: 33%;

        }

        &.panel--25 {

          left: 25%;

        }

        &.panel--x2 {

          width: 201%;
          transform: translate3d(-50%, 0, 0);

        }

        &.panel--x3 {

          width: 300%;
          transform: translate3d(-67%, 0, 0);
          
        }

        &.js-active {

          &.panel--x2 {

            transform: translate3d(50%, 0, 0);

          }

          &.panel--x3 {

            transform: translate3d(33%, 0, 0);

          }

        }        

      }

    }

    &.panel--right {

      right: 0;
      border-left: 1px solid rgba(255, 255, 255, .25);      
      transform: translate3d(100%, 0, 0);

      &.js-active {

        transform: translate3d(0, 0, 0);

        .panel__extend {

          &.js-active {

            transform: translate3d(-100%, 0, 0);

          }

        }

      } 

      // & > .panel__frame {

      //   direction: rtl;

      //   .panel__block {

      //     direction: ltr;

      //   }

      // }

      // &.panel--tabs {

      //   & > .panel__frame {

      //     padding-left: 0;
      //     padding-right: 4.25rem;

      //   }

      //   .panel__tab-list {

      //     left: auto;
      //     right: 15px;

      //   }

      // }           

      .panel__extend {

        &.panel--50 {

          right: 50%;

        }

        &.panel--33 {

          right: 33%;

        }

        &.panel--25 {

          right: 25%;

        }

        &.panel--x2 {

          width: 201%;

        }

        &.panel--x3 {

          width: 301%;

        }

        &.js-active {

          // transform: translate3d(-100%, 0, 0);

        }

      }     

    }

    &.panel--tabs {

      > .panel__frame {

        padding-left: 4.25rem;

      }

      .panel__control {

        left: 4.25rem;

      }

    }

    &.panel--controls {

      > .panel__frame {

        padding-bottom: 4.25rem;

      }

    }

    &.js-extend {

      &::before {

        opacity: .8;
        visibility: visible;

      }

    }

    &::before {

      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      background: black;

      z-index: 15;

      opacity: 0;
      visibility: hidden;

      transition: visibility .3s cubic-bezier(.8, 0, .5, 1), opacity .3s cubic-bezier(.8, 0, .5, 1);

    }    

	}

  .panel__frame,
  .panel__extend {

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

  }

  .panel__frame {

    background: rgba(250, 250, 250, 1);
    color: #333;

    z-index: 10;

    overflow: auto;

  }

  .panel__extend {

    background: #fff;
    left: 0%;

    z-index: 5;

    transform: translate3d(0, 0, 0);
    transition: transform .4s cubic-bezier(.8, 0, .5, 1);

    h2 {

      padding-left: 1.5rem;
      color: #222;
      font-weight: 400;

    }

    .panel__frame {

      background: none;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      // position: relative;

    }

    .input {

      border: 1px solid rgba(0, 0, 0, .12);
      background: rgba(255, 255, 255, .1);
      color: #333;
      // box-shadow: 0 0 4px #d3d3d3;

      &:focus,
      &:active,
      &.js-active {

        border: 1px solid rgba(0, 0, 0, .3);

      }

    } 

    .input__label {

      color: #222;

    }

    .dropdown__button .icon__svg {

      stroke: #333;

    }

    .panel__block {

      padding: 1rem 3rem;

      &:nth-of-type(2n+2) {

        background: #f4f4f4;

      }

    }   

  }

  .panel__control,
  .panel__extend-control {

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #eee;
    background: #f4f4f4;
    padding: 1rem;

    z-index: 10;

  }

  .panel__control {

    position: fixed;
    background: none;
    border: 0; 
    padding: 0;
    transform: translate3d(0, 50%, 0);

    &:hover {

      .panel__buttons {

        transform: translate3d(0, -49%, 0);

      }

    }  

    .panel__buttons {

      border-top: 1px solid #2e313a; 
      padding: 1rem;
      background: rgba(#1b1d22, .7);
      transform: translate3d(0, 100%, 0);

      transition: transform .4s ease;

    }

  }

  .repeater-form__buttons-left,
  .repeater-form__buttons-right {

    display: inline-block;
    width: 50%;

  }

  .repeater-form__buttons-right {

    text-align: right;

  }

  .panel__buttons {

    text-align: left;

  }

	.panel__block {

		padding: 1.5rem 3rem;

	}

  .panel__block--client-picker {

    margin-top: 1rem;

    h2 {

      margin-bottom: 1.5rem;

    }

  }

  .panel__heading {

    font-weight: 400;
    margin: 3rem -3rem 2rem;
    padding: 0 3rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, .07);

    &:first-child {

      margin-top: .5em;

    }

    .sum {

      color: #06a0df;

    }

  }

  .panel__instruction {

    font-size: .9rem;
    margin-bottom: 1em;
    color: #676767;
    font-style: italic;    

  }

  .panel__tab-list {

    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    background: #3b4956;

    list-style-type: none;
    padding: 0;
    z-index: 20;
    transform: translate3d(0, 0, 0);

  }

  .panel__tab-item {

    position: relative;

    &:hover {

      .panel__tab-tip {

        opacity: 1;
        visibility: visible;
        // transition-delay: 1s;

      }

      .panel__tab-button  {

        background-color: #14222e;

        .icon {

          transform: scale(1) translate3d(0, -.25rem, 0);
          
        }     

      }      

    }

  }

  .panel__tab-tip {

    display: block;
    font-size: .6rem;
    text-align: center;
    color: #fff;
    padding: .5em;

    position: absolute;
    top: calc(100% - 24px);
    left: 0;
    right: 0;
    z-index: 21;
    letter-spacing: .05em;

    border-radius: 1px;

    white-space: nowrap;

    opacity: 0;
    visibility: hidden;

    transition: opacity .3s ease, visibility .3s ease;

  }

  .panel__tab-button {

    -webkit-appearance: none;
    border: 0;
    background: none;
    border-radius: 0;
    padding: 1.25rem;
    outline: none;

    &.js-active {

      background-color: #182938;

      .icon__svg {

        stroke: #f7d46f;

      }

    }

    .icon {

      width: 1.75rem;
      height: 1.75rem;
      transform: scale(.85) translate3d(0, 0, 0);
      transition: transform .15s ease;

    }

  }

  .button--snapshot {

    background: #f3f3f3;
    border: 1px solid #ddd;
    color: #182938;
    display: inline-flex;
    align-items: center;

    &:hover,
    &:focus,
    &:active {

      background: #eee;
      color: #182938;

    }

    .icon {

      margin-right: .85em;
      height: 1.5rem;
      width: 1.5rem;

      .icon__svg {
        fill: transparent;
        stroke: #182938;
        width: 1.5rem;
        height: 1.5rem;
      }

    }

  }

  .panel__snapshots-list {

    list-style-type: none;
    padding: 0;
    border: 0;

  }

  .panel__snapshots-item {

    position: relative;
    margin-bottom: 1rem;

    &:last-child {

      margin-bottom: 2rem;

    }

    .date-wrap {

      margin-top: 1rem;

    }

    .gps_fixed {

      display: block;
      position: absolute;
      top: .1em;
      left: -1.5rem;

      svg {

        stroke: #06a0df;

      }

    }

  }

  .panel__snapshots-ctrl {
 
    button {

      appearance: none;
      border: 0;
      background: none;
      padding: 0;
      margin-right: .5rem;

      &.js-active {

        color: #06a0df;

      }

    }


    .edit,    
    .remove {

      color: #fff;
      background-color: #aaa;
      -webkit-appearance: none;

      border: 0;
      border-radius: 10px;

      font-size: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      padding: 0;
      position: relative;
      top: -1px;
      margin-right: .125rem;

      transition: background-color .1s ease, opacity .1s ease, visibility .1s ease;    

    }

    .remove {

      &:hover,
      &:focus,
      &:active {

        background-color: #f26673;

      }

      &::before {

        content: '-';
        font-size: 10px;
        position: relative;
        top: -1px;

      }

    }

    .edit {

      &:hover,
      &:focus,
      &:active {

        background-color: #06a0df;

      }

      .icon {

        width: 8px;
        height: 8px;

      }

      .icon__svg {

        fill: #fff;

      }

    }

  }

  .savings-wrap {

    display: flex;
    align-items: center;
    flex-direction: row;

    > div {

      width: 50%;
      margin-bottom: 0;

    }

    .checkbox-wrap {

      position: relative;
      top: 8px;
    }

  }

</style>



// WEBPACK FOOTER //
// Panel.vue?5748f2c6